import { render, staticRenderFns } from "./TimeBorderPadding.vue?vue&type=template&id=5233dc86&"
import script from "./TimeBorderPadding.vue?vue&type=script&lang=js&"
export * from "./TimeBorderPadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports